<template>
  <div
    class="course_content use_common"
    :class="{
      course_content_bottom: !isBeginActivity,
      course_content_bottom_iphoneX: isIphoneX,
    }"
  >
    <!---->
    <div v-if="!isEndActivity" v-cloak>
      <!-- 头部 展示 当前学员和 登录按钮 -->
      <div class="user-info-header">
        <div class="container" v-if="U2AT">
          <!-- 已登录状态 -->
          <div class="user-info">
            <img
              v-if="studentAvatar"
              class="avatar"
              :src="studentAvatar"
              alt="头像"
            />

            <div class="user-details">
              <div class="user-name">{{ studentName || "未选择学员" }}</div>
              <div class="user-phone" v-if="studentCode">
                ( {{ studentCode }})
              </div>
            </div>
          </div>
          <div class="switch-btn" @click="showStudentPopup">切换</div>
        </div>
        <div class="container" v-else>
          <!-- 未登录状态 -->
          <div class="login-tip">尚未登录</div>
          <div class="login-btn" @click="goToLogin">登录</div>
        </div>
      </div>

      <div v-if="activityInfo.bannerUrl">
        <img class="course_bg" :src="activityInfo.bannerUrl" alt="" />
        <div class="title_radius"></div>
      </div>
      <div class="banner_height" v-else></div>
      <!--标题栏内容-->
      <div class="title_content" v-if="navNumberList.length > 0">
        <div
          class="school_title_content flex_box"
          @click="selectSchoolType(1)"
          v-if="navNumberList.indexOf(0) > -1"
        >
          <img class="school_icon" src="../../assets/schoolicon.png" alt="" />
          <div class="school_title tow">校区：{{ schoolName || "请选择" }}</div>
          <img
            class="down_arrow_icon"
            src="../../assets/downarrow.png"
            alt=""
          />
        </div>
        <div
          class="school_title_content flex_box"
          @click="selectSchoolType(2)"
          v-if="navNumberList.indexOf(1) > -1"
        >
          <img
            class="school_icon"
            src="../../assets/schoolclassicon.png"
            alt=""
          />
          <div class="school_title tow">年级：{{ gradeName || "请选择" }}</div>
          <img
            class="down_arrow_icon"
            src="../../assets/downarrow.png"
            alt=""
          />
        </div>
        <div class="subject_content" v-if="navNumberList.indexOf(2) > -1">
          <div
            class="subject_icon_content subject_icon_content_bottom flex_box"
          >
            <img
              class="subject_icon"
              src="../../assets/subjecticon.png"
              alt=""
            />
            <div class="subject_title">选择科目</div>
          </div>
          <div class="subject_line"></div>
          <div class="subject_type_content flex_box">
            <span
              class="subject_name tow"
              v-for="(subject, index) in subjectList"
              :class="{
                subject_name_color:
                  selectSubjectId !== '' && Number(selectSubjectId) === index,
              }"
              :key="index"
              @click="selectSubject(subject, index)"
              >{{ subject }}</span
            >
          </div>
        </div>
        <div
          class="school_title_content flex_box"
          @click="selectSchoolType(3)"
          v-if="
            navNumberList.indexOf(3) > -1 &&
            selectNavString == navNumberShowString
          "
        >
          <img
            class="school_icon"
            src="../../assets/schooltimeicon.png"
            alt=""
          />
          <div class="school_title tow">时间：{{ timeName || "请选择" }}</div>
          <img
            class="down_arrow_icon"
            src="../../assets/downarrow.png"
            alt=""
          />
        </div>
      </div>
      <!--课程内容-->
      <v-reload
        :on-infinite-load="onInfiniteLoad"
        :parent-pull-up-state="pullUpState"
        :footer-content="isShowPullUpFooter"
      >
        <div class="course_package_list add_style" v-cloak>
          <div class="package_content" v-if="courseList">
            <div class="package_title flex_box package_title_style">
              <div class="package_title_text tow">{{ courseTitle }}</div>
            </div>
            <div
              class="course_list_details detail_style"
              v-for="(courseItem, courseIndex) in courseList"
              :key="courseIndex"
              :class="{
                course_list_details_opacity: courseItem.registrationState === 6,
              }"
              @click="selectCourse(courseItem)"
            >
              <div class="course_name_content">
                <span
                  class="class_type"
                  v-if="courseItem.seasonName && courseItem.productType == 1"
                  >{{ courseItem.seasonName }}</span
                >
                <span
                  class="teaching_methods"
                  v-if="
                    courseItem.teachingMethod &&
                    teachingMethod(courseItem.teachingMethod)
                  "
                  >{{ teachingMethod(courseItem.teachingMethod || "") }}</span
                >
                <span class="course_name">{{ courseItem.className }}</span>
              </div>
              <div
                class="flex_box class_num_time"
                v-if="courseItem.productType == 1"
              >
                <span class="lessons_num">{{ courseItem.classCode }}</span>
                <span class="lessons_num">{{
                  getClassLessonTimes(
                    courseItem.lessonTimes,
                    courseItem.realMinutes || 0
                  )
                }}</span>
                <span
                  class="lessons_num"
                  v-if="getClassStay(courseItem.classMode || '')"
                  >住宿班</span
                >
                <span
                  class="course_quota"
                  v-if="
                    courseItem.registrationState === 1 &&
                    isFew(
                      courseItem.maxNum - courseItem.usableCount,
                      courseItem.maxNum,
                      courseItem.registrationState
                    )
                  "
                  >名额紧张</span
                >
                <span
                  class="course_quota"
                  v-if="
                    courseItem.registrationState === 2 ||
                    courseItem.registrationState === 3
                  "
                  >已开课/可插班</span
                >
                <span
                  class="course_quota open_course_status"
                  v-if="courseItem.registrationState === 4"
                  >已开课</span
                >
                <span
                  class="course_quota open_course_status"
                  v-if="courseItem.registrationState === 6"
                  >已报满</span
                >
              </div>
              <div class="flex_box class_num_time" v-else>
                <span class="lessons_num">{{ courseItem.classCode }}</span>
              </div>
              <div class="flex_box course_details">
                <img
                  class="learn_place_icon"
                  src="../../assets/cardaddricon.png"
                />
                <span class="class_num tow">{{ courseItem.learnPlace }}</span>
              </div>
              <div class="flex_box course_details">
                <img
                  class="card_year_icon"
                  src="../../assets/cardyearicon.png"
                />
                <span class="class_num" v-if="courseItem.productType == 1">{{
                  formatDate(
                    new Date(courseItem.startDate.replace(/-/g, "/") + "+0800"),
                    "yyyy/MM/dd"
                  ) +
                  "至" +
                  formatDate(
                    new Date(courseItem.endDate.replace(/-/g, "/") + "+0800"),
                    "yyyy/MM/dd"
                  )
                }}</span>
                <span class="class_num" v-else>{{
                  formatDate(
                    new Date(courseItem.startDate.replace(/-/g, "/") + "+0800"),
                    "yyyy/MM/dd"
                  ) + "开始"
                }}</span>
              </div>
              <div class="course_details course_time_details">
                <img
                  class="card_time_icon"
                  src="../../assets/cardtimeicon.png"
                />
                <div class="flex_box">
                  <span class="time_details text_ellipsis_two">{{
                    courseItem.learnTime
                  }}</span>
                </div>
              </div>

              <div
                class="first_shift_time"
                v-if="
                  (courseItem.registrationState === 2 ||
                    courseItem.registrationState === 3) &&
                  courseItem.productType == 1
                "
              >
                插班首次课时间：{{ courseItem.insertLessonTimeText }}
              </div>
              <div class="course_dot_line" v-else></div>

              <div class="flex_box lesson_and_price_content">
                <div
                  class="flex_box"
                  v-if="
                    courseItem.teacherList && courseItem.teacherList.length >= 1
                  "
                >
                  <div
                    class="flex_box more_teacher_content"
                    v-for="(teacherinfo, index) in courseItem.teacherList.slice(
                      0,
                      2
                    )"
                    :key="index"
                  >
                    <img
                      class="teacher_icon"
                      v-if="teacherinfo.newLogoUrl"
                      :src="teacherinfo.newLogoUrl"
                      onerror="javascript:this.src='https://cdn.xdf.cn/souke/h5-pages/components/teacher-info-card/images/default_teacher_photo.svg'"
                    />
                    <img class="teacher_icon" :src="randomAvatar()" v-else />
                    <span class="teacher_name">{{
                      teacherinfo.teacherName
                    }}</span>
                  </div>
                  <div
                    class="teacher_name"
                    v-if="
                      courseItem.teacherList &&
                      courseItem.teacherList.length > 2
                    "
                  >
                    ...
                  </div>
                </div>
                <div class="flex_box more_teacher_content" v-else>
                  <img class="teacher_icon" :src="randomAvatar()" />
                  <span class="teacher_name">待定</span>
                </div>

                <div class="price_symbol_content">
                  <span class="price_symbol">¥</span>
                  <span class="course_price">{{ courseItem.price }}</span>
                </div>
              </div>
              <div class="select_icon">
                <img
                  v-if="
                    courseItem.isSelect && courseItem.registrationState !== 6
                  "
                  src="../../assets/selectcourse.png"
                  alt=""
                />
                <img
                  v-else-if="courseItem.registrationState === 6"
                  src="../../assets/nocourse.png"
                  alt=""
                />
                <img v-else src="../../assets/unselectcourse.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </v-reload>

      <div
        class="check_all_course flex_box"
        @click="checkAllCourse"
        v-if="activityInfo.detailUrl && total > 10"
      >
        <span class="all_course_title">查看全部</span>
        <img
          class="course_left_arrow"
          src="../../assets/courseleftarrow.png"
          alt=""
        />
      </div>
      <!--课程图片内容-->
      <div class="course_img" v-if="activityInfo.detailUrl || total <= 2">
        <img :src="activityInfo.detailUrl" alt="" />
      </div>
      <div v-if="!isInIframe">
        <!--底部按钮-->
        <div
          class="activity_time"
          v-if="!isBeginActivity"
          :class="{ activity_time_bottom: isIphoneX }"
        >
          活动将于{{ beginTimeText }}开始
        </div>
        <div
          class="footer_content flex_box newfooter"
          :class="{ footer_content_bottom: isIphoneX }"
        >
          <div class="leftside">
            <!-- 添加价格显示区域 -->
            <div class="price-info" v-if="preferentialInfo">
              <div class="price-amount">
                <span>合计</span> ¥{{ preferentialInfo.finalPrice }}
              </div>
              <div class="price-amount">
                <span>已优惠：</span> ¥{{ preferentialInfo.discountAmount }}
              </div>
            </div>
          </div>

          <div class="rightside">
            <div class="buy_course" @click="payMoney">立即下单</div>
          </div>
        </div>
      </div>
    </div>

    <!--活动已结束-->
    <div v-if="isEndActivity">
      <end-activity></end-activity>
    </div>

    <!--弹窗内容-->
    <div class="school_list_bg" v-if="isShowPopupList">
      <div class="school_content">
        <div class="school_title_content flex_box">
          <span class="school_title">{{ popupTitle }}</span>
          <img
            class="close_icon"
            src="../../assets/closeicon.png"
            alt=""
            @click="closePopupList"
          />
        </div>

        <div class="school_list">
          <div
            class="school_list_info"
            v-for="(item, index) in filterTypeList"
            :key="index"
            @click="selectFilterItem(item, index)"
          >
            <div
              class="school_name tow"
              :class="{
                school_name_color:
                  selectTypeId !== '' && Number(selectTypeId) === index,
              }"
            >
              {{ item }}
            </div>
            <div class="dot_line"></div>
          </div>
        </div>
      </div>
    </div>
    <studentPopuper
      v-if="ispopshow"
      :show="ispopshow"
      :list="studentList"
      @closepop="closepop"
      @checkedCode="checkedCode"
    />
  </div>
</template>

<script>
import wxSdk from "../../libs/wxsdk.js";
import PullUpReload from "../../components/pullUpReload";
import EndActivity from "../../components/endActivity";
import studentPopuper from "../../components/studentPopuper";
import {
  getNewMarketInfo,
  getMarketClassList,
  recordChannel,
  getMarketDimension,
  checkWxLogin,
  getStudentList,
  getGan,
  calculatePreferential,
  getGiftRules,
} from "../../libs/api";
import {
  formatDateUtil,
  teachingMethodUtil,
  getClassLessonTimesUtil,
  getClassStayUtil,
  isFewUtil,
  getIphoneXType,
  isWeChat,
  getUrlParam,
} from "../../libs/util";
import configData from "../../libs/conf";
import { Indicator, Toast } from "mint-ui";
import Cookies from "js-cookie";

const avatarMap = [];

export default {
  name: "newsinglecourse",
  metaInfo() {
    return {
      title: this.pageName,
    };
  },
  components: {
    "v-reload": PullUpReload,
    "end-activity": EndActivity,
    studentPopuper,
  },
  data() {
    return {
      phone: "",
      pageName: "新东方专题活动",
      isFixedHeight: false, // 是否固定页面高度
      isShowPopupList: false, // 是否显示弹窗列表
      popupTitle: "", // 弹窗标题
      subjectList: [], // 科目列表
      navList: [], // 导航栏
      filterTypeList: [], // 筛选列表
      selectTypeId: "", // 选中筛选类型的Id
      filterNum: "", // 1: 学校 2: 年级  3: 时间
      schoolName: "", // 校区名字
      gradeName: "", // 年级名字
      subjectName: "", // 科目名字
      timeName: "", // 时间名字
      selectSchoolId: "", // 选中的学校Id
      selectGradeId: "", // 选中的校区Id
      selectSubjectId: "", // 选中的科目Id
      selectTimeId: "", // 选中的时间Id
      navNumberList: [], // 导航栏的存在的数字
      navNumberShowString: "", // 导航栏的存在先显示的数字
      selectNavString: "", // 选择学校0，时间1，科目2，显示时间栏
      activityInfo: "", // 活动信息
      beginTimeText: "", // 活动开始时间
      isBeginActivity: true, // 是否开始活动
      isEndActivity: false, // 是否结束活动
      courseList: [], // 课程列表
      activityId: "", // 活动Id
      pageNumber: 1, // 当前页数
      pageSize: 10, // 一页多少个
      total: "", // 总量
      pullUpState: 1, // 子组件的pullUpState状态
      isShowPullUpFooter: true, // 是否显示加载更多底部
      U2AT: "", // token
      schoolId: "", // 学校Id
      courseTitle: "", // 列表标题
      isIosApp: false, // 是否是iosApp
      isIphoneX: false, // 是否iphoneX
      isLoadFull: false, // 是否加载完
      isWeChat: false, //  是否在微信环境内
      wxNickName: "", // 打点微信数据
      studentCode: "",
      studentName: "", // 加购学员姓名
      studentPhone: "", // 加购学员手机号
      studentAvatar: "", // 加购学员头像
      ispopshow: false,
      studentList: [],
      agentName: "", // 邮箱或者手机号
      agn: "", // 推广渠道
      isInIframe: false, // 暂时只在推广中心使用
      preferentialInfo: null, // 存储优惠计算结果
      giftRules: null, // 存储礼品规则
      selectCourseTimer: null, // 添加一个用于防抖的计时器变量
    };
  },
  created() {
    let hostname = top.location.hostname;
    if (
      hostname == configData.promotion ||
      hostname == configData.promotionTestOne ||
      hostname == configData.promotionTestTwo ||
      hostname == configData.promotionTestThree
    ) {
      this.isInIframe = true;
    }

    if (top.location != self.location && !this.isInIframe) {
      let queryParams = this.$route.query;
      if (queryParams.pageValue) {
        queryParams = getUrlParam(queryParams.pageValue);
      }
      let activityId = queryParams.activityId || "";
      let channelId = queryParams.channelId || "";
      let agn = queryParams.agn || "";
      let params = `channelId=${channelId}&activityId=${activityId}&agn=${agn}`;
      let url = `/single/course?${params}`;
      this.$router.push(url);
      sessionStorage.clear();
    }
  },
  mounted() {
    this.U2AT = Cookies.get("U2AT");
    console.log("*********测试推广中心*********");
    // 直播环境下
    if (top.location != self.location && !this.isInIframe) {
      return;
    }
    // 专题详情
    Indicator.open({
      text: "加载中...",
      spinnerType: "fading-circle",
    });
    let queryParams = this.$route.query;
    if (queryParams.pageValue) {
      queryParams = getUrlParam(queryParams.pageValue);
    }
    // 获取标题参数
    let courserTitle = JSON.parse(sessionStorage.getItem("courserTitle"));
    if (
      !courserTitle ||
      (courserTitle &&
        queryParams &&
        courserTitle.activityId != queryParams.activityId)
    ) {
      sessionStorage.clear();
      courserTitle = queryParams;
    }
    // console.log('获取参数', courserTitle)
    if (courserTitle) {
      this.schoolName = courserTitle.schoolName || "";
      this.selectSchoolId = courserTitle.selectSchoolId || "";
      this.gradeName = courserTitle.gradeName || "";
      this.selectGradeId = courserTitle.selectGradeId || "";
      this.subjectName = courserTitle.subjectName || "";
      this.selectSubjectId = courserTitle.selectSubjectId || "";
      this.timeName = courserTitle.timeName || "";
      this.selectTimeId = courserTitle.selectTimeId || "";
      this.filterNum = Number(courserTitle.filterNum) || "";
      this.activityId = courserTitle.activityId || "";
      this.channelId = courserTitle.channelId || "";
      this.agn = courserTitle.agn || "";
      this.selectNavString = courserTitle.selectNavString || "";
      if (courserTitle.selectSchoolId === 0) {
        this.selectSchoolId = 0;
      }
      if (courserTitle.selectGradeId === 0) {
        this.selectGradeId = 0;
      }
      if (courserTitle.selectSubjectId === 0) {
        this.selectSubjectId = 0;
      }
      if (courserTitle.selectTimeId === 0) {
        this.selectTimeId = 0;
      }
      this.saveTitleInfo();
      switch (Number(this.filterNum)) {
        case 1: // 校区名字
          this.selectTypeId = this.selectSchoolId;
          break;
        case 2: // 年级名字
          this.selectTypeId = this.selectGradeId;
          break;
        case 3: // 时间名字
          this.selectTypeId = this.selectTimeId;
          break;
        case 4: // 科目名字
          this.selectTypeId = this.selectSubjectId;
          break;
      }
    }
    // 判断是否在微信环境内,是否授权
    this.isWeChat = isWeChat();
    // this.checkWxLogin()

    // 获取纬度及课程列表
    this.getMarketInfo();
    this.getMarketClassList();
    this.getGan();

    // 打点数据
    gio("page.set", {
      activity_id: this.activityId,
      channel_id: this.channelId,
    });

    // 是否在app内并且是否是ios
    if (xdfJs.xdfhybird.inApp && !xdfJs.xdfhybird.android) {
      this.isIosApp = true;
    }

    // 判断是否IphoneX
    this.isIphoneX = getIphoneXType();
    // 后退刷新页面
    window.addEventListener(
      "pageshow",
      (e) => {
        if (
          e.persisted ||
          (window.performance && window.performance.navigation.type == 2)
        ) {
          window.location.reload();
        }
      },
      false
    );

    // 获取礼品规则
    this.getGiftRules();
  },
  methods: {
    randomAvatar() {
      const number = Math.floor(Math.random() * 3);
      return avatarMap[number];
    },
    checkedCode(data) {
      this.studentCode = data.studentCodes[0].studentCode;
      this.studentAvatar = data.studentCodes[0].avatarUrlSmall;
      this.studentName = data.realName;
      this.studentPhone = data.mobile;
      this.ispopshow = false;
    },
    closepop() {
      this.ispopshow = false;
    },
    // 选择筛选选项
    selectSchoolType(num) {
      document.documentElement.style.overflow = "hidden";
      this.filterNum = num;
      this.selectTypeId = "";
      this.isShowPopupList = true;
      switch (num) {
        case 1: // 校区名字
          this.selectTypeId = this.selectSchoolId;
          this.popupTitle = "校区";
          this.getMarketDimension(1);
          break;
        case 2: // 年级名字
          this.selectTypeId = this.selectGradeId;
          this.popupTitle = "年级";
          this.getMarketDimension(2);
          break;
        case 3: // 时间名字
          this.selectTypeId = this.selectTimeId;
          this.popupTitle = "时间";
          this.getMarketDimension(3);
          break;
      }
    },
    // 选择筛选列表
    selectFilterItem(itemName, itemIndex) {
      this.pullUpState = 1;
      Indicator.open({
        text: "加载中...",
        spinnerType: "fading-circle",
      });
      document.documentElement.style.overflow = "scroll";
      this.isShowPopupList = false;
      this.selectTypeId = itemIndex;
      switch (this.filterNum) {
        case 1: // 校区名字
          this.selectSchoolId = itemIndex;
          this.schoolName = itemName;
          this.selectNavString = "";
          if (this.selectNavString.indexOf("0") == -1) {
            this.selectNavString += "0";
          }
          // 重新选择清空数据
          this.selectGradeId = "";
          this.gradeName = "";
          this.selectSubjectId = "";
          this.subjectName = "";
          this.selectTimeId = "";
          this.timeName = "";
          break;
        case 2: // 年级名字
          this.selectGradeId = itemIndex;
          this.gradeName = itemName;
          if (this.selectNavString.indexOf("0") > -1) {
            this.selectNavString = "0";
          } else {
            this.selectNavString = "";
          }
          if (this.selectNavString.indexOf("1") == -1) {
            this.selectNavString += "1";
          }
          // 重新选择清空数据
          this.selectSubjectId = "";
          this.subjectName = "";
          this.selectTimeId = "";
          this.timeName = "";
          break;
        case 3: // 时间名字
          this.selectTimeId = itemIndex;
          this.timeName = itemName;
          break;
      }
      this.saveTitleInfo();
      this.courseList = [];
      this.pageNumber = 1;
      this.getMarketClassList();
      if (this.filterNum === 1 || this.filterNum === 2) {
        this.getMarketDimension(4, 1);
      }
      this.getWxSdk();
    },
    // 选择科目
    selectSubject(subjectName, subjectIndex) {
      this.pullUpState = 1;
      this.filterNum = 4;
      this.subjectName = subjectName;
      this.selectSubjectId = subjectIndex;
      // 重新选择清空数据
      this.selectTimeId = "";
      this.timeName = "";
      if (this.selectNavString.indexOf("2") == -1) {
        this.selectNavString += "2";
      }
      this.saveTitleInfo();
      this.courseList = [];
      this.pageNumber = 1;
      this.getMarketClassList();
      this.getWxSdk();
    },
    // 存储标题参数
    saveTitleInfo() {
      // 存储学校名字
      let courserTitleInfo = {
        schoolName: this.schoolName,
        selectSchoolId: this.selectSchoolId,
        gradeName: this.gradeName,
        selectGradeId: this.selectGradeId,
        subjectName: this.subjectName,
        selectSubjectId: this.selectSubjectId,
        timeName: this.timeName,
        selectTimeId: this.selectTimeId,
        filterNum: this.filterNum,
        activityId: this.activityId,
        channelId: this.channelId,
        selectNavString: this.selectNavString,
        agn: this.agn,
      };
      sessionStorage.setItem("courserTitle", JSON.stringify(courserTitleInfo));
      // 在对接中心使用
      if (this.isInIframe) {
        let iframeUrl = this.getHttpUrl();
        window.location.replace(iframeUrl);
      }
    },
    // 关闭弹窗
    closePopupList() {
      document.documentElement.style.overflow = "scroll";
      this.isShowPopupList = false;
    },
    // 获取专题详情
    getMarketInfo() {
      getNewMarketInfo(this.activityId).then((res) => {
        let resData = res;
        if (resData.code == 1) {
          let data = resData.data;
          this.activityInfo = data.activityinfo;
          let nowTime = new Date(
            this.activityInfo.nowTime.replace(/-/g, "/") + "+0800"
          ).valueOf();
          let beginTime = new Date(
            this.activityInfo.beginTime.replace(/-/g, "/") + "+0800"
          ).valueOf();
          let beginTimeText = formatDateUtil(
            new Date(this.activityInfo.beginTime.replace(/-/g, "/") + "+0800"),
            "MM月dd日 HH:mm"
          );
          let endTime = new Date(
            this.activityInfo.endTime.replace(/-/g, "/") + "+0800"
          ).valueOf();
          this.beginTimeText = beginTimeText;
          this.phone = this.activityInfo.connectPhone || "";
          this.schoolId = this.activityInfo.schoolId;
          this.pageName = this.activityInfo.title;

          this.checkWxLogin();

          // 活动未开始
          if (nowTime < beginTime) {
            this.isBeginActivity = false;
          }
          // 活动已结束
          if (nowTime > endTime) {
            this.isEndActivity = true;
          }

          // 是否有详情图片
          if (this.activityInfo.detailUrl) {
            this.isShowPullUpFooter = false;
          }

          // 科目在选择校区及年级后重新赋值
          this.subjectList = data.subjectSet;

          // 标题列表
          this.navList = data.navList;
          this.navList.forEach((navItem) => {
            if (navItem.type != 4) {
              this.navNumberList.push(navItem.type);
              if (navItem.type < 3) {
                this.navNumberShowString += navItem.type;
              }
            }
          });

          if (
            this.schoolName ||
            this.gradeName ||
            this.subjectName ||
            this.classTime
          ) {
            this.getMarketDimension(this.filterNum, 1);
          }
          // 微信分享
          this.getWxSdk();

          // 获取活动信息后，如果用户已登录，获取学员列表
          if (this.U2AT) {
            this.getDefaultStudent();
          }
        }
      });
    },
    // 获取营销纬度
    getMarketDimension(num, secondNum) {
      // alert(num)
      let data = {
        activityId: this.activityId,
        campusName: this.schoolName,
        gradeName: this.gradeName,
        subjectName: this.subjectName,
        classTime: "",
      };
      // 获取全部学校
      if (num === 1) {
        data = {
          activityId: this.activityId,
          campusName: "",
          gradeName: "",
          subjectName: "",
          classTime: "",
        };
      }
      // 获取全部年级
      if (num === 2) {
        data = {
          activityId: this.activityId,
          campusName: this.schoolName,
          gradeName: "",
          subjectName: "",
          classTime: "",
        };
      }
      // 获取全部时间
      if (num === 4) {
        data = {
          activityId: this.activityId,
          campusName: this.schoolName,
          gradeName: this.gradeName,
          subjectName: "",
          classTime: "",
        };
      }
      getMarketDimension(data).then((res) => {
        if (secondNum != 1) {
          this.isFixedHeight = true;
          this.isShowPopupList = true;
        }
        if (res.code == 1) {
          let resData = res.data;
          if (num === 1) {
            this.filterTypeList = resData.campusNameSet;
          } else if (num === 2) {
            this.filterTypeList = resData.gradeNameSet;
          } else {
            this.filterTypeList = resData.classTimeSet;
          }
          if (num !== 3) {
            this.subjectList = resData.subjectNameSet;
          }
        }
      });
    },
    // 获取班级列表
    getMarketClassList() {
      let data = {
        campusName: this.schoolName,
        gradeName: this.gradeName,
        classTime: this.timeName,
        subjectName: this.subjectName,
        activityId: this.activityId,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      };
      getMarketClassList(data).then((res) => {
        Indicator.close();
        let courseData = res.data;
        //课程列表
        this.pageNumber++;
        if (courseData.classList) {
          courseData.classList.forEach((classItem) => {
            // 购物车有数量时要自动匹配
            if (classItem) {
              let index =
                this.singleCartList &&
                this.singleCartList.indexOf(classItem.classCode);
              if (this.singleCartList && index > -1) {
                // 用于套餐按钮的变化
                classItem.isSelect = true;
              } else {
                classItem.isSelect = false;
              }
            }
          });

          this.courseList = this.courseList.concat(courseData.classList);
          if (this.courseList && this.courseList.length <= 2) {
            this.isShowPullUpFooter = false;
          } else {
            if (!this.activityInfo.detailUrl) {
              this.isShowPullUpFooter = true;
            }
          }
          if (!this.isShowPullUpFooter && this.courseList.length > 10) {
            this.courseList = this.courseList.slice(0, 9);
          }
        }
        this.courseTitle = "选产品";
        this.total = courseData.sum;
        this.isLoadFull = courseData.isFull;
        this.getStartPullUpState();
      });
    },
    // 获取上拉加载的pullUpState状态
    getStartPullUpState() {
      if (this.courseList.length) {
        if (this.total <= this.pageSize) {
          // 修改子组件的pullUpState状态
          this.pullUpState = 3;
        } else {
          this.pullUpState = 1;
        }
      } else {
        this.pullUpState = 0;
      }
    },
    // 上拉加载
    onInfiniteLoad(done) {
      // 当有课程图片时，不支持加载更多
      if (!this.isShowPullUpFooter) {
        return;
      }
      if (this.pullUpState === 1) {
        this.getPullUpMoreData();
      }
      done();
    },
    // 上拉一次加载更多的数据
    getPullUpMoreData() {
      // 调用课程列表
      if (this.total <= this.courseList.length || this.isLoadFull) {
        this.pullUpState = 3;
      } else {
        this.pullUpState = 1;
        this.getMarketClassList();
      }
    },
    // 单个课程选择方法添加防抖
    selectCourse(course) {
      // 如果已经有计时器在运行，清除它
      if (this.selectCourseTimer) {
        clearTimeout(this.selectCourseTimer);
      }

      // 设置一个新的计时器，延迟300毫秒执行
      this.selectCourseTimer = setTimeout(() => {
        // 原有的方法逻辑
        if (course.registrationState === 6) {
          return;
        }

        // 检查是否已选择该课程
        let isAlreadySelected = false;
        for (const item of this.courseList) {
          if (item.classCode === course.classCode && item.isSelect) {
            isAlreadySelected = true;
            break;
          }
        }

        // 如果是取消选择，直接允许
        if (isAlreadySelected) {
          // 修改为礼品课程的选择逻辑
          this.courseList.forEach((classItem) => {
            if (classItem.classCode === course.classCode) {
              classItem.isSelect = !classItem.isSelect;
            }
          });
        } else {
          // 如果是新选择，需要验证是否超过最大规则
          // 获取当前已选课程
          const selectedCourses = this.courseList.filter(
            (item) => item.isSelect
          );

          // 计算当前已选的唯一科目
          const currentSubjects = [];
          for (const item of selectedCourses) {
            if (!currentSubjects.includes(item.subjectName)) {
              currentSubjects.push(item.subjectName);
            }
          }

          // 检查新选择的课程是否会导致科目数量增加
          let willAddNewSubject = !currentSubjects.includes(course.subjectName);

          // 如果会增加新科目，验证是否超过最大规则
          if (
            willAddNewSubject &&
            this.giftRules &&
            this.giftRules.length > 0
          ) {
            let maxRuleTotal = 0;
            for (const rule of this.giftRules) {
              const total = rule.buyCount + rule.giftCount;
              if (total > maxRuleTotal) {
                maxRuleTotal = total;
              }
            }

            if (currentSubjects.length + 1 > maxRuleTotal) {
              Toast({
                message: `限购${maxRuleTotal}个科目`,
                duration: 2000,
                className: "noticeError",
              });
              return; // 阻止选择
            }
          }

          // 通过验证，允许选择
          this.courseList.forEach((classItem) => {
            if (classItem.classCode === course.classCode) {
              classItem.isSelect = true;
            }
          });
        }

        // 获取已选课程（更新后的）
        const selectedCourses = this.courseList.filter((item) => item.isSelect);

        // 如果有选中的课程且用户已登录，调用优惠计算接口
        if (selectedCourses.length > 0 && this.U2AT) {
          this.calculatePreferential(selectedCourses);
        } else {
          // 未登录时，直接计算总价格
          const totalPrice = selectedCourses.reduce(
            (sum, course) => sum + Number(course.price || 0),
            0
          );

          // 存储价格信息，但不调用接口
          this.preferentialInfo = {
            preferentialId: "",
            discountAmount: 0,
            finalPrice: totalPrice,
          };
        }
      }, 300); // 300毫秒的防抖延迟
    },
    // 添加优惠计算方法
    calculatePreferential(selectedCourses) {
      console.log("selectedCourses", selectedCourses);
      // 计算原始总价格（用于接口调用失败时显示）
      const totalPrice = selectedCourses.reduce(
        (sum, course) => sum + Number(course.price || 0),
        0
      );

      // 准备接口所需参数
      const params = {
        classList: selectedCourses.map((item, index) => ({
          classCode: item.classCode,
          salePrice: item.price,
          submitOrder: index + 1,
        })),
        schoolId: this.schoolId,
        studentCode: this.studentCode || "",
      };

      // 调用优惠计算接口
      calculatePreferential(params)
        .then((res) => {
          if (res.code == 200 || res.code == 1) {
            // 处理优惠计算结果
            this.preferentialInfo = {
              originalPrice: res.data.totalOriginalPrice,
              discountAmount: res.data.totalPreferentialAmount,
              finalPrice:
                res.data.totalSalePrice - res.data.totalPreferentialAmount,
            };
            // 可以在这里更新UI显示优惠信息
          } else {
            // 接口返回错误时，显示原价
            this.preferentialInfo = {
              originalPrice: totalPrice,
              discountAmount: 0,
              finalPrice: totalPrice,
            };

            Toast({
              message: res.message || "优惠计算失败",
              duration: 2000,
              className: "noticeError",
            });
          }
        })
        .catch((err) => {
          // 接口调用异常时，显示原价
          this.preferentialInfo = {
            originalPrice: totalPrice,
            discountAmount: 0,
            finalPrice: totalPrice,
          };

          console.error("优惠计算出错:", err);
          Toast({
            message: "网络异常，请稍后再试",
            duration: 2000,
            className: "noticeError",
          });
        });
    },
    // 查看所有课程
    checkAllCourse() {
      let params = this.getParams();
      let url = `/newsingle/list?${params}`;
      this.$router.push(url);
    },
    // 教学方式
    teachingMethod(methodCode) {
      return teachingMethodUtil(methodCode);
    },
    // 课时，课次
    getClassLessonTimes(lessonTimes, realMinutes) {
      return getClassLessonTimesUtil(lessonTimes, realMinutes);
    },
    // 住宿班
    getClassStay(modeCodes) {
      return getClassStayUtil(modeCodes);
    },
    // 名额紧张
    isFew(currentNum, maxNum, bmState) {
      return isFewUtil(currentNum, maxNum, bmState);
    },
    // 时间格式化
    formatDate(source, format) {
      return formatDateUtil(source, format);
    },
    // 记录渠道
    recordChannel() {
      let data = {
        channelId: this.channelId,
        u2at: this.U2AT,
        wxNickname: this.wxNickName || "",
        agn: this.agn || "",
      };
      recordChannel(data).then((res) => {
        let reaData = res;

        if (reaData.code == 1 && reaData.data && reaData.data.userid) {
          sessionStorage.setItem("userId", reaData.data.userid);
          gio("setUserId", reaData.data.userid);
        }
      });
    },
    // 记录渠道
    checkWxLogin(num) {
      checkWxLogin().then((res) => {
        let reaData = res;
        let url = this.getHttpUrl();
        // 微信授权
        if (reaData.code == 4002 && this.isWeChat && !this.isInIframe) {
          let wxLogin = configData.wxlogin;
          window.parent.location.href =
            wxLogin + "&returnUrl=" + encodeURIComponent(url);
        }

        if (reaData.code == 200 && reaData.data && reaData.data.wxNickName) {
          this.wxNickName = reaData.data.wxNickName;
        }

        // 测试数据 记录渠道
        if (!num) {
          this.U2AT = Cookies.get("U2AT");
          let userId = sessionStorage.getItem("userId");
          if (this.U2AT && !userId) {
            this.recordChannel();
          }
        }

        // 登录过期
        if (num === 1) {
          if (reaData.code == 4000) {
            let urlLogin = configData.h5Login;
            window.parent.location.href =
              urlLogin + "&redirect_uri=" + encodeURIComponent(url);
          } else {
            let orderUrl = this.getOrderUrl();
            window.parent.location.href = orderUrl;
          }
        }
      });
    },

    payMoney() {
      if (!this.isBeginActivity) {
        Toast({
          message: "当前活动还未开始哦~",
          duration: 2000,
          className: "noticeError",
        });
        return;
      }

      // 获取已选课程
      const selectedCourses = this.courseList.filter((item) => item.isSelect);

      if (selectedCourses.length === 0) {
        Toast({
          message: "请选择报名产品",
          duration: 2000,
          className: "noticeError",
        });
        return;
      }

      // 验证是否符合礼品规则
      if (this.giftRules && this.giftRules.length > 0) {
        // 获取所选课程的唯一科目数量
        const uniqueSubjects = [
          ...new Set(selectedCourses.map((course) => course.subjectName)),
        ];
        const uniqueSubjectCount = uniqueSubjects.length;

        // 找出规则中最小的买赠总数和最大的买赠总数
        const minRuleTotal = Math.min(
          ...this.giftRules.map((rule) => rule.buyCount)
        );
        const maxRuleTotal = Math.max(
          ...this.giftRules.map((rule) => rule.buyCount + rule.giftCount)
        );
        console.log(uniqueSubjectCount, minRuleTotal, maxRuleTotal);
        // 如果科目数量小于最小规则要求，允许直接下单
        if (uniqueSubjectCount < minRuleTotal) {
          // 不做验证，允许直接下单
        }
        // 如果科目数量超过最大买赠总数，提示错误
        else if (uniqueSubjectCount > maxRuleTotal) {
          Toast({
            message: `限购${maxRuleTotal}个科目`,
            duration: 2000,
            className: "noticeError",
          });
          return;
        }
        // 如果科目数量在最小和最大之间，检查是否符合任一规则
        else {
          let isValidRule = false;

          // 检查是否满足任意一条规则
          for (const rule of this.giftRules) {
            if (uniqueSubjectCount === rule.buyCount + rule.giftCount) {
              isValidRule = true;
              break;
            }
          }

          if (!isValidRule) {
            // 构建提示信息
            // 找出最接近的规则
            let closestRule = this.giftRules.reduce((prev, curr) => {
              const prevDiff = Math.abs(
                prev.buyCount + prev.giftCount - uniqueSubjectCount
              );
              const currDiff = Math.abs(
                curr.buyCount + curr.giftCount - uniqueSubjectCount
              );
              return prevDiff < currDiff ? prev : curr;
            });

            const targetCount = closestRule.buyCount + closestRule.giftCount;
            let ruleMessage = "";

            if (uniqueSubjectCount < targetCount) {
              // 需要再选择科目
              ruleMessage = `您已选购${uniqueSubjectCount}科，可免费再选${
                targetCount - uniqueSubjectCount
              }科，参加买${closestRule.buyCount}赠${
                closestRule.giftCount
              }的活动~`;
            } else {
              // 科目数量过多时，不提供具体减少建议
              ruleMessage = "所选科目数量不符合赠送规则";
            }

            Toast({
              message: ruleMessage,
              duration: 2000,
              className: "noticeError",
            });
            return;
          }
        }
      }

      // 在app中去登陆
      if (xdfJs.xdfhybird.inApp) {
        this.getAppToken();
        return;
      }

      if (this.U2AT) {
        // 已登录，跳转到礼品订单页面
        this.checkWxLogin(1);
      } else {
        // 未登录
        let urlLogin = configData.h5Login;
        window.parent.location.href =
          urlLogin + "&redirect_uri=" + encodeURIComponent(this.getHttpUrl());
      }
    },
    // 获取app的token
    getAppToken() {
      xdfJs.xdfhybird.getUser((data) => {
        // 判断用户是否登陆
        if (
          data &&
          data.user &&
          !!data.user.userId &&
          data.user.userId.length > 0
        ) {
          let token = data["user"]["accessToken"];
          this.U2AT = token;
          Cookies.set("U2AT", token, { expires: 30, domain: "xdf.cn" });
          this.recordChannel();
          // 跳转到支付
          let url = this.getOrderUrl();
          if (token) {
            xdfJs.xdfhybird.openURL("xdfapp://student/web", { url: url });
          }
        } else {
          xdfJs.xdfhybird.openURL("xdfapp://student/login", {});
        }
      });
    },
    // 微信分享
    getWxSdk() {
      let shareObj = {
        urlLogo: this.activityInfo.shareUrl || "", // 分享图标
        desc: this.activityInfo.shareDesc || "",
      };
      shareObj.title = this.activityInfo.shareTitle || this.activityInfo.title;
      let params = this.getParams();
      shareObj.link =
        configData.originUrl +
        "newsingle/course?pageValue=" +
        encodeURIComponent(params);
      wxSdk.getWxSdk(shareObj);
    },
    getParams() {
      let params =
        `activityId=${this.activityId}&channelId=${this.channelId}&schoolName=${this.schoolName}&gradeName=${this.gradeName}&timeName=${this.timeName}&subjectName=${this.subjectName}` +
        `&selectSchoolId=${this.selectSchoolId}&selectGradeId=${this.selectGradeId}&selectTimeId=${this.selectTimeId}&selectSubjectId=${this.selectSubjectId}&selectNavString=${this.selectNavString}&filterNum=${this.filterNum}&agn=${this.agn}`;
      return params;
    },
    // 获取分享链接
    getHttpUrl() {
      let httpUrl = configData.originUrl + "gift/course?";
      let params = this.getParams();
      let url = httpUrl + params;
      return url;
    },

    getGan() {
      if (this.$route.query.agentName) {
        this.agentName = this.$route.query.agentName;
        return;
      }
      Indicator.open({
        text: "加载中...",
        spinnerType: "fading-circle",
      });
      // 专题详情
      let data = {
        activityId: this.activityId,
        agn: this.agn,
      };
      getGan(data)
        .then((res) => {
          Indicator.close();
          let resData = res;
          if (resData.code == 1) {
            this.agentName = resData.data.agentName;
          }
        })
        .catch(() => {
          Indicator.close();
        });
    },
    // 提取订单URL
    getOrderUrl() {
      // 获取已选课程
      const selectedCourses = this.courseList.filter((item) => item.isSelect);
      let classCodeList = selectedCourses
        .map((item) => item.classCode)
        .join(",");

      let marketingSource = this.activityId + "_" + this.channelId;
      if (this.agn) {
        marketingSource = this.activityId + "_" + this.agn;
      }

      let marketingSourceExt = this.activityInfo.uniActivityId;
      let params =
        `appId=${configData.appId}&systemSource=${configData.systemSource}&schoolId=${this.schoolId}` +
        `&classCodes=${classCodeList}&studentCode=${this.studentCode}&preOrderCode=&marketingSource=${marketingSource}&marketingSourceExt=${marketingSourceExt}&isGift=1`;

      // 如果有优惠信息，添加到参数中
      if (this.preferentialInfo) {
        params += `&preferentialId=${
          this.preferentialInfo.preferentialId || ""
        }`;
      }

      return `${configData.h5Bm}/page-h5bm/order?${params}`;
    },
    // 获取礼品规则
    getGiftRules() {
      getGiftRules(this.activityId)
        .then((res) => {
          if (res.code === "1") {
            this.giftRules = res.data;

            // 可以在这里根据规则更新UI或其他逻辑
            // 例如：显示规则说明、根据规则限制课程选择等
          } else {
            console.error("获取礼品规则失败:", res.message);
          }
        })
        .catch((err) => {
          console.error("获取礼品规则出错:", err);
        });
    },
    // 获取默认学员
    getDefaultStudent() {
      getStudentList({
        schoolId: this.schoolId,
      })
        .then((res) => {
          if (res.code === "200" && res.data && res.data.length > 0) {
            this.studentList = res.data;

            // 默认选择第一个学员
            const firstStudent = res.data[0];
            if (
              firstStudent &&
              firstStudent.studentCodes &&
              firstStudent.studentCodes.length > 0
            ) {
              this.studentCode = firstStudent.studentCodes[0].studentCode;
              console.log("firstStudent", firstStudent);
              this.studentAvatar = firstStudent.studentCodes[0].avatarUrlSmall;
              this.studentName = firstStudent.realName;
              this.studentPhone = firstStudent.mobile;
            }
          }
        })
        .catch((err) => {
          console.error("获取学员列表失败:", err);
        });
    },
    // 显示学员选择弹窗
    showStudentPopup() {
      // 获取学员列表
      getStudentList({
        schoolId: this.schoolId,
      })
        .then((res) => {
          if (res.code === "200" && res.data && res.data.length > 0) {
            this.studentList = res.data;
            this.ispopshow = true;
          } else {
            Toast({
              message: "暂无可选学员",
              duration: 2000,
              className: "noticeError",
            });
          }
        })
        .catch((err) => {
          console.error("获取学员列表失败:", err);
          Toast({
            message: "获取学员列表失败",
            duration: 2000,
            className: "noticeError",
          });
        });
    },
    // 跳转到登录页面
    goToLogin() {
      let urlLogin = configData.h5Login;
      window.parent.location.href =
        urlLogin + "&redirect_uri=" + encodeURIComponent(this.getHttpUrl());
    },
  },
};
</script>

<style lang="less" scoped>
.course_content {
  padding-bottom: 100px;
  .course_bg {
    width: 100%;
  }
  .title_radius {
    position: relative;
    width: 100%;
    height: 20px;
    background: #fff;
    border-radius: 20px 20px 0px 0px;
    margin-top: -20px;
    margin-bottom: 12px;
  }

  .banner_height {
    width: 100%;
    height: 32px;
  }
  /*标题栏内容*/
  .title_content {
    margin-bottom: 80px;
    .school_title_content {
      width: 686px;
      height: 96px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 20px 0px rgba(206, 223, 241, 0.3);
      border-radius: 20px;
      margin: 0 auto 32px;
      padding-left: 16px;
      padding-right: 40px;
      position: relative;
      .school_icon {
        width: 68px;
        height: 68px;
      }
      .school_title {
        width: 514px;
        font-size: 30px;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;
        font-weight: 400;
      }
      .down_arrow_icon {
        width: 18px;
        height: 12px;
        margin-left: auto;
      }
    }
    .school_title_content:after {
      content: ".";
      color: transparent;
      width: 200%;
      height: 200%;
      border: 1px solid rgba(237, 240, 247, 0.7);
      border-radius: 20px;
      transform-origin: 0 0;
      transform: scale(0.5, 0.5);
      position: absolute;
      left: 0;
      top: 0;
    }
    .subject_content {
      width: 686px;
      min-height: 162px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 20px 0px rgba(206, 223, 241, 0.3);
      border-radius: 20px;
      border: 1px solid rgba(237, 240, 247, 0.7);
      margin: 0 auto 32px;
      padding-top: 14px;
      padding-left: 16px;
      padding-bottom: 4px;
      .subject_icon_content {
        .subject_icon {
          width: 68px;
          height: 68px;
        }
        .subject_title {
          font-size: 30px;
          color: rgba(51, 51, 51, 1);
          line-height: 40px;
        }
      }
      .subject_icon_content {
        margin-bottom: 14px;
      }
      .subject_line {
        width: 622px;
        height: 1px;
        background: rgba(227, 227, 227, 1);
        margin-left: 14px;
        margin-bottom: 30px;
        transform: scale(1, 0.5);
      }
      .subject_type_content {
        flex-wrap: wrap;
        padding-left: 16px;
        .subject_name {
          width: 144px;
          height: 72px;
          background: rgba(243, 243, 243, 1);
          border-radius: 40px;
          opacity: 0.8;
          font-size: 28px;
          color: rgba(136, 136, 136, 1);
          line-height: 72px;
          text-align: center;
          margin-right: 16px;
          margin-bottom: 24px;
        }
        .subject_name_color {
          background: linear-gradient(
            90deg,
            rgba(255, 162, 70, 1) 0%,
            rgba(255, 135, 15, 1) 100%
          );
          box-shadow: 0px 4px 14px 0px rgba(255, 127, 0, 0.5);
          color: #fff;
          opacity: 1;
        }
      }
    }
  }
  /*查看全部课程*/
  .check_all_course {
    justify-content: center;
    margin-top: 56px;
    margin-bottom: 60px;
    .all_course_title {
      font-size: 24px;
      color: rgba(252, 148, 53, 1);
      line-height: 34px;
      margin-right: 20px;
    }
    .course_left_arrow {
      width: 10px;
      height: 18px;
    }
  }
  /*课程图片内容*/
  .course_img {
    margin-top: 60px;
    width: 100%;
    img {
      display: block;
      width: 100%;
    }
  }

  /*学校列表*/
  .school_list_bg {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 1001;
    background: rgba(0, 0, 0, 0.7);
    .school_content {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width: 750px;
      background: #fff;
      border-radius: 20px 20px 0px 0px;
      overflow: auto;
      padding: 42px 32px 0;
      .school_title_content {
        justify-content: space-between;
        margin-bottom: 30px;
        .school_title {
          font-size: 40px;
          font-weight: bold;
          color: rgba(30, 30, 30, 1);
          line-height: 56px;
        }
        .close_icon {
          width: 32px;
          height: 32px;
          margin-top: -16px;
        }
      }
      .school_list {
        max-height: 800px;
        min-height: 660px;
        overflow-y: scroll;
        .school_list_info {
          .school_name {
            font-size: 30px;
            color: rgba(30, 30, 30, 1);
            line-height: 42px;
          }
          .school_name_color {
            color: #1fb895;
          }
          .dot_line {
            width: 686px;
            height: 0.5px;
            background: rgba(227, 227, 227, 1);
            border-radius: 10px;
            transform: scale(1, 0.5);
            margin: 28px auto 30px;
          }
        }
      }
    }
  }
}
.course_content_bottom {
  padding-bottom: 170px;
}
.course_content_bottom_iphoneX {
  padding-bottom: 168px;
}
.package_title_style {
  margin-bottom: 40px !important;
}
.detail_style {
  margin-top: 0 !important;
  margin-bottom: 32px !important;
}
.add_style {
  margin-top: 8px;
}
.select_all {
  width: 170px !important;
}
.newfooter {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100px;
  padding-left: 10px;
  padding-right: 10px;
  background: #fff;
  justify-content: space-between;
  box-shadow: 0 6px 20px 0 rgba(206, 223, 241, 0.7);
  .leftside {
    display: flex;
    .call_phone {
      display: block;
      .call_phone_icon {
        width: 40px;
        height: 40px;
        margin-top: 10px !important;
        margin-bottom: 0 !important;
      }
      .call_phone_text {
        display: block;
        margin-top: 4px;
        font-size: 20px;
        font-weight: 400;
        color: #666;
      }
    }
    // align-items: center;
    .cartwrapper {
      margin-left: 38px;
      position: relative;
      img {
        margin-left: 10px;
      }
      .cart-count {
        position: absolute;
        top: -5px;
        right: -5px;
        width: 30px;
        height: 30px;
        background: linear-gradient(180deg, #ff371a, #ff692b);
        box-shadow: 0px 1px 3px 0px rgba(255, 135, 15, 0.5);
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        color: #fff;
        font-size: 22px;
      }
      .cart-count2 {
        font-size: 20px;
      }
      .call_phone_icon {
        width: 40px;
        margin-top: 10px !important;
        margin-bottom: 0 !important;
      }
      .call_phone_text {
        display: block;
        margin-top: 4px;
        font-size: 20px;
        line-height: 28px;
        font-weight: 400;
        color: #666666;
      }
    }
    .cartwrapper_left {
      margin-left: 0;
    }
  }
  .rightside {
    width: 220px;
    border-radius: 40px;
    display: flex;
    font-size: 28px;
    overflow: hidden;

    .buy_course {
      width: 220px;
      background: linear-gradient(
        90deg,
        rgba(255, 95, 40, 1) 0%,
        rgba(255, 105, 43, 1) 100%
      );
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
    }
    // .buy_course {
    //     width:300px;
    //     height:80px;
    //     background:linear-gradient(90deg,rgba(255,95,40,1) 0%,rgba(255,105,43,1) 100%);
    //     border-radius: 200px;
    //     font-size:32px;
    //     color:rgba(255,255,255,1);
    //     line-height:80px;
    //     text-align: center;
    //     font-weight: normal;
    // }
  }
}
.footer_content_bottom {
  height: 146px;
  padding-bottom: 46px;
}
.cart-error-mask {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  z-index: 98;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cart-error-text {
  width: 590px;
  // max-height: 66vh;
  background: #fff;
  border-radius: 20px;
  font-size: 28px;
  // position: fixed;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -60%);
  z-index: 98;
  h3 {
    font-size: 40px;
    line-height: 56px;
    margin: 0;
    padding: 44px 0 24px 0;
    text-align: center;
  }
  .cart-error-wrap {
    line-height: 48px;
    padding: 0 36px 0 30px;
    color: #1e1e1e;
    overflow-y: scroll;
    max-height: 50vh;
    font-weight: 300;
    /deep/ div {
      padding-left: 36px;
      background: url("../../assets/warning.svg") no-repeat 0 8px;
      background-size: 28px 28px;
    }
    /deep/ hr {
      border: 0;
      height: 1px;
      margin: 30px 0;
      background: #e3e3e3;
    }
  }
  .handle-cart-error-text {
    height: 90px;
    line-height: 90px;
    margin-top: 34px;
    border-top: 1px solid #e3e3e3;
    font-size: 32px;
    color: #1fb895;
    text-align: center;
  }
}

/* 在适当的位置添加礼品规则说明 */
.gift-rules {
  margin: 15px;
  padding: 15px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);

  .rules-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }

  .rules-content {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
    margin-bottom: 10px;
  }

  .rules-item {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin-top: 8px;

    .label {
      color: #666;
    }

    .value {
      color: #ff6b00;
      font-weight: bold;
    }
  }
}

/* 用户信息头部样式 */
.user-info-header {
  background: #fff;
  padding: 15px;
  margin-bottom: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .user-info {
    display: flex;
    align-items: center;

    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 10px;
    }

    .user-details {
      display: flex;
      align-items: center;
      .user-name {
        font-size: 26px;
        font-weight: bold;
        color: #333;
      }

      .user-phone {
        font-size: 26px;
        color: #666;
        margin-left: 5px;
        vertical-align: middle;
      }
    }
  }

  .switch-btn,
  .login-btn {
    padding: 8px 20px;
    background: #1fb895;
    color: #fff;
    border-radius: 20px;
    font-size: 26px;
  }

  .login-tip {
    font-size: 26px;
    color: #666;
  }
}

.price-info {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .price-amount {
    font-size: 28px;
    line-height: 1.2;

    &:first-child {
      font-weight: bold;
      color: #ff5f28;
      font-size: 32px;
      margin-bottom: 5px;
    }

    &:last-child {
      color: #999;
      font-size: 24px;
    }

    span {
      color: #666;
      font-size: 24px;
      font-weight: normal;
      margin-right: 5px;
    }
  }
}
</style>
